import React, { useEffect, useState } from 'react'
import { Button, IconButton, InputAdornment, TextField, Toolbar, Tooltip, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { AddOutlined, Clear, Search } from '@material-ui/icons'
import clsx from 'clsx'
import { useHistory, useParams } from 'react-router-dom'
import { HouseholdVisitsFilterButton } from '../../Components/Schedule/HouseholdVisitsFilterButton'
import useCurrentUser from '../../../../hooks/useCurrentUser'
import useSelectedFacility from '../../../../hooks/useSelectedFacility'
import useSelectedHousehold from '../../../../hooks/useSelectedHousehold'

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	toolbarItemsWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		'& > *': {
			marginRight: '16px',
			marginBottom: 8
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '19px 25px 16px 25px !important'
	},
	searchField: {
		minWidth: 150
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	}
}))

export const HouseholdVisitsToolbar = React.forwardRef((props, ref) => {
	const classes = useStyles()
	const theme = useTheme()
	const history = useHistory()

	const [search, setSearch] = useState('')
	let { tableRef } = props

	const { isGroomer } = useCurrentUser()

	const { household } = useSelectedHousehold()
	const { facility } = useSelectedFacility()

	const onSearchChange = (searchText) => {
		tableRef.current.dataManager.changeSearchText(searchText)
		tableRef.current.onSearchChangeDebounce(searchText)
	}

	useEffect(() => {
		onSearchChange(search)
	}, [search])

	return (
		<div ref={ref} className={classes.toolbarWrapper}>
			<Toolbar className={classes.toolbar}>
				<div className={classes.toolbarItemsWrapper}>
					<Typography
						variant="h6"
						color="primary"
						style={{
							fontSize: '22px',
							fontWeight: 800,
							lineHeight: '30px',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis'
						}}>
						Appointments
					</Typography>
					<HouseholdVisitsFilterButton />
					<TextField
						value={search}
						className={classes.searchField}
						onChange={(event) => setSearch(event.target.value)}
						placeholder="Search"
						variant="filled"
						InputProps={{
							startAdornment: (
								<InputAdornment position="start">
									<Tooltip title="Search">
										<Search fontSize="small" />
									</Tooltip>
								</InputAdornment>
							),
							endAdornment: (
								<InputAdornment position="end">
									<IconButton
										disabled={!search}
										onClick={() => setSearch('')}
										aria-label="Clear">
										<Clear fontSize="small" aria-label="clear" />
									</IconButton>
								</InputAdornment>
							),
							inputProps: {
								'aria-label': 'Search'
							}
						}}
					/>
					<Button
						variant="outlined"
						className={clsx(classes.headerButton, classes.addAppointmentButton)}
						startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
						size="large"
						onClick={() => {
							if (isGroomer) {
								history.push(
									`/facilities/${facility?._id}/appointment/create${household ? `?household=${household._id}` : ''
									}&type=grooming`
								)
							} else {
								history.push(
									`/facilities/${facility?._id}/appointment/create${household ? `?household=${household._id}` : ''
									}`
								)
							}
						}}>
						Appointment
					</Button>
				</div>
			</Toolbar>
		</div>
	)
})
